import { useAtomValue } from 'jotai';
import { useUserDesc } from '../shared/use-user-desc';
import { $CurrentAvailableUserOrNull } from '@user/shared/atoms/current-user';
import { $PageLevelTraffic } from 'shared/atoms';
import { FC } from 'react';

export const OG: FC = () => {
  const user = useAtomValue($CurrentAvailableUserOrNull);
  const description = useUserDesc();
  const { canonicalUrl } = useAtomValue($PageLevelTraffic);

  if (!user) {
    return null;
  }

  return (
    <>
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content="article" />
      <meta property="og:title" content={user.nickName} />
      <meta property="og:description" content={description} />
      <meta property="og:image:type" content={user.avatar.endsWith('.webp') ? 'image/webp' : 'image/jpeg'} />
      <meta property="og:image" content={user.avatar} />
    </>
  );
};
